"use strict";

var React = require('react/addons'),
    ReactRouter = require('react-router'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    BS = require('react-bootstrap'),
    Constants = require('../../constants'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    CurrentUser = require('../../shared/CurrentUser'),
    ContactForm = require('../../partials/builder/BuilderContactForm'),
    ProjectGallery = require('../../partials/project/ProjectGallery'),
    FluxBone = require('../../mixins/FluxBone'),
    Link = require('../../components/Link'),
    Developer = require('../../models/Developer'),
    ListingCollection = require('../../collections/Projects'),
    URI = require('urijs'),
    ReactShare = require('react-share'),
    SB = ReactShare.ShareButtons,
    Clipboard = require('../../external/clipboard'),
    toastr = require('toastr');

var ToolboxDashboard = React.createClass({displayName: "ToolboxDashboard",

    contextTypes: {
        router: React.PropTypes.func
    },

    mixins: [
        FluxBone.CollectionMixin('project', 'sync'),
        FluxBone.CollectionMixin('CurrentUser', 'sync')
    ],

    updateState: function(props) {
        var listingCollection, isBuilder,
            state = this.state || {};

        props = props || this.props;

        isBuilder = props.builder && props.builder.constructor === Developer;
        listingCollection = state.listingCollection || new ListingCollection();

       

        return {
            listingCollection: props.builder ? props.builder.listingCollection : undefined,
            isBuilder: isBuilder
        };
    },

    getInitialState: function() {
        return this.updateState();
    },
    /**
     * This is to ensure that when subroutes transistion they trigger recheck router state and render
     */
    componentWillReceiveProps: function(props) {
        this.setState(this.updateState(props));
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            model = props.project || props.builder,
            data = model ? model.toJSON() : {},
            hasProject = !!props.project,
            listingCollection = state.listingCollection,
            title = props.title + ' - Dashboard';


        return (
             React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        hasProject && (React.createElement(ToolboxSidebar, {project: props.project})), 
                        React.createElement("div", {className: !hasProject ? 'col-xs-12' : 'col-sm-9'}, 
                            React.createElement("h1", null, "Dashboard"), 
                            React.createElement("p", {className: "margin-bottom-10"}, 
                                React.createElement("span", {className: "blue-text"}, data.name), " promotes and encourages the participation of real estate agents and brokerages." + ' ' + 
                                "This area contains tools to help you market ", React.createElement("span", {className: "blue-text"}, data.name), " to your buyers. If you have questions" + ' ' + 
                                "about this project or the builder, please contact the builder's representative."
                            ), 

                            !hasProject ? (
                                React.createElement("div", null, 
                                    React.createElement("h2", {className: "orange-text margin-bottom-20"}, "Select a community to access:"), 
                                    React.createElement(ProjectGallery, {store: listingCollection, fixedWidth: true, linkToToolbox: true, builder: props.builder})
                                )
                            ) : (
                                React.createElement("div", null, 
                                    React.createElement(Link, {to: "Contact", className: "btn-u btn-u-lg btn-u-blue btn-u-inverted btn-u-narrow margin-bottom-10"}, 
                                        "Contact Builder"
                                    ), 
                                    props.project.hasServiceType('AGENT_PORTAL') && (
                                        React.createElement(BS.Panel, {className: "margin-bottom-10 panel-no-header", header: (React.createElement("h2", {className: "orange-text"}, "Your Agent Tracker Link:"))}, 
                                            React.createElement("p", {className: "margin-bottom-10"}, 
                                                "Below is your personalized Agent Tracker link to market ", React.createElement("span", {className: "blue-text"}, data.name), ". You can use" + ' ' + 
                                                "this link in any of your electronic marketing such as on websites, emails, social media, etc.."
                                            ), 
                                            React.createElement(BS.Input, {readOnly: true, type: "text", groupClassName: "", className: "orange-border", value: data.websiteRedirect}), 
                                            Constants.canClipboardCopy && (
                                                React.createElement("div", {className: "btn-u btn-u-ultra-narrow btn-u-orange", onClick: this.copyToClipboard.bind(null, data.websiteRedirect)}, "Copy Code to Clipboard")
                                            ), 
                                            React.createElement("div", {className: "share-wrap margin-top-20"}, 
                                                React.createElement("h2", {className: "panel-title orange-text"}, "Automatically market on Social Media:"), 
                                                React.createElement("p", null, "Click on a logo to post your Agent Tracker Link on: "), 
                                                React.createElement("div", {className: "share-icons"}, 
                                                    React.createElement(SB.FacebookShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_Facebook_35x35.png'})), 
                                                    React.createElement(SB.LinkedinShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_LinkedIn_35x35.png'})), 
                                                    React.createElement(SB.TwitterShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_Twitter_35x35.png'}))
                                                )
                                            )
                                        )
                                    ), 

                                    React.createElement(ContactForm, {model: props.project})

                                )
                            )

                        )
                    ), 
                    React.createElement(Footer, {trackerId: "agent-toolbox-dashboard"})
                )
            )
        );
    },

    copyToClipboard: function(valueToCopy) {
        Clipboard.copy(valueToCopy);
        toastr.success('Copied to Clipboard!');
    }
});
module.exports = ToolboxDashboard;
